<template>
  <v-container class="full-height-container px-6">
    <v-row>
      <v-col cols="12" class="d-flex align-center flex-column login-container">
        <v-img
          v-if="isLogoBase64 || !customLogo"
          :width="$vuetify.breakpoint.mobile ? 171 : 200"
          :height="$vuetify.breakpoint.mobile ? 60 : 60"
          contain
          :src="
            customLogo
              ? customLogo
              : require(`@/assets/logo${isDark ? '-white' : ''}.svg`)
          "
          class="mb-10"
        ></v-img>
        <div
          v-else
          v-html="customLogo"
          class="mb-10 d-flex"
          :width="$vuetify.breakpoint.mobile ? 171 : 200"
          :height="$vuetify.breakpoint.mobile ? 60 : 60"
        ></div>
        <v-card elevation="4" class="d-flex">
          <v-card-title class="d-flex justify-center">
            <h1 class="font-weight-800 text-center">{{ $t('heading.forgotPasswordPage.title') }}</h1>
          </v-card-title>
          <v-card-text class="pb-2">
            <v-form ref="form" @submit.prevent>
              <v-text-field
                outlined
                :label="$t('form.label.emailAddress')"
                :rules="emailRules"
                v-model="emailForForgotPassword"
                large
                solo
                flat
                hide-details="auto"
                validate-on-blur
                autocomplete="email"
                name="email"
                @keydown.enter="sendPasswordResetLink"
              ></v-text-field>
              <v-btn
                large
                @click.prevent=""
                color="primary"
                block
                elevation="0"
                class="forgot-password-btn mt-6"
                @click="sendPasswordResetLink"
                >{{ $t('button.resetPasswordSend') }}
              </v-btn>
            </v-form>
            <div class="d-flex justify-center mt-6">
              <p>
                {{ $t('message.falseAlert') }}
                <a
                  href="/login"
                  class="href"
                  @click.prevent="$router.push({ path: '/login' })"
                  >{{ $t('button.signIn') }}</a
                >
              </p>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-img
      :src="require('@/assets/illustrations/radio-lines.svg')"
      class="radio-lines"
    />
  </v-container>
</template>

<script>
import Auth from "@/apis/Auth";

import FormRulesMixin from "../mixins/FormRulesMixin";
import Api from "@/apis/Api";

export default {
  mixins: [FormRulesMixin],
  data: function () {
    return {
      errors: [],
      loading: false,
      emailForForgotPassword: "",
    };
  },
  beforeRouteEnter: async (__, _, next) => {
    await Auth.remoteAuthCheck().then((response) => {
      if (response === true) {
        next((vm) => {
          vm.$root.$emit("loggedIn", true);
          next(vm.$route.query.redirect || "/");
        });
      } else {
        next();
      }
    });
  },
  computed: {
    isDark() {
      return this.$vuetify.theme.dark;
    },
    customLogo: function () {
      if(this.$vuetify.theme.dark && this.$store.state.ThemeModule.darkLogo) {
        return this.$store.state.ThemeModule.darkLogo
      }

      if(!this.$vuetify.theme.dark && this.$store.state.ThemeModule.lightLogo) {
        return this.$store.state.ThemeModule.lightLogo
      }

      return false
    },
    isLogoBase64: function() {
      return this.customLogo &&  this.customLogo.trim().startsWith('data:image/');
    }
  },
  methods: {
    handleEnter(e) {
      if (e.code === "Enter" || e.code === "NumpadEnter") {
        this.login();
      }
    },
    sendPasswordResetLink() {
      if (this.$refs.form.validate() === false) {
        return;
      }
      Api.post("/forgot-password", { email: this.emailForForgotPassword })
        .then((response) => {
          this.$store.dispatch("addAlert", {
            success: true,
            successMessage: response.data.message,
          });
          this.forgotPasswordEnabled = false;
        })
        .catch((error) => {
          this.$store.dispatch("addAlert", {
            success: false,
            errorMessage: error.response.data.errors.email[0],
          });
        });
      this.emailForForgotPassword = "";
    },
  },
};
</script>


<style src="./Login.scss" lang="scss" scoped />

